import { randomNumber } from '../../../utilities'
import { PatientMedicationsConstants } from './patientMedications.constants'
import { IPatientMedication, IPatientMedicationsAction, IPatientMedicationsState } from './patientMedications.types'

export const initialPatientMedication = (): IPatientMedication => {
  return {
    key: randomNumber().toString(),
    name: null,
    dose: null,
    doseUnits: null,
    route: null,
    frequency: null,
  }
}

export const initialPatientMedicationsState: IPatientMedicationsState = {
  name: null,
  dose: null,
  doseUnits: null,
  route: null,
  frequency: null,
  showSingleSelectLookup: false,
  patientMedication: null,
  patientMedicationsList: [],
  patientMedicationPNNV: null,
  areOptionsLoading: false,
  response: {},
  currentMedication: null,
  lastOralIntake: '',
  __patientMedicationPNNVToggle: false,
}

export function patientMedicationsReducer(
  state: IPatientMedicationsState = initialPatientMedicationsState,
  action: IPatientMedicationsAction
): IPatientMedicationsState {
  switch (action.type) {
    case PatientMedicationsConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PatientMedicationsConstants.SET_NAME:
      return { ...state, name: action.name, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SET_DOSE:
      return { ...state, dose: action.dose, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SET_DOSE_UNITS:
      return { ...state, doseUnits: action.doseUnits, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SET_ROUTE:
      return { ...state, route: action.route, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SET_FREQUENCY:
      return { ...state, frequency: action.frequency, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.ADD_MEDICATION:
      return {
        ...state,
        patientMedicationsList: [...state.patientMedicationsList, initialPatientMedication()],
      }
    case PatientMedicationsConstants.SET_MEDICATION:
      return { ...state, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SET_CURRENT_MEDICATION:
      return { ...state, currentMedication: action.currentMedication }
    case PatientMedicationsConstants.SET_MEDICATIONS_LIST:
      return { ...state, patientMedicationsList: action.patientMedicationsList }
    case PatientMedicationsConstants.SET_MEDICATION_PNNV:
      return { ...state, patientMedicationPNNV: action.patientMedicationPNNV }
    case PatientMedicationsConstants.DELETE_MEDICATION:
      return { ...state, patientMedication: action.patientMedication }
    case PatientMedicationsConstants.SHOW_SINGLE_SELECT_LOOKUP:
      return { ...state, showSingleSelectLookup: action.showSingleSelectLookup }
    case PatientMedicationsConstants.SET_ARE_OPTIONS_LOADING:
      return { ...state, areOptionsLoading: action.areOptionsLoading }
    case PatientMedicationsConstants.SET_PATIENT_MEDICATIONS:
      return { ...action.patientMedications }
    case PatientMedicationsConstants.SET_LAST_ORAL_INTAKE:
      return { ...state, lastOralIntake: action.lastOralIntake }
    case PatientMedicationsConstants.SET_PATIENT_MEDICATION_PNNV_TOGGLE:
      return { ...state, __patientMedicationPNNVToggle: action.__patientMedicationPNNVToggle }
    case PatientMedicationsConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case PatientMedicationsConstants.RESET_STATE:
      return { ...initialPatientMedicationsState }
    default:
      return state
  }
}
